import {IconTypes} from "@/shared/models/icon-types";
import {SearchResult, SearchResultImage} from "../models/search-result-model";
import {IVUSearchIndexModel as IVUSearchIndexModel} from "../models/vu-search-index-model";

import DateTimeMapper from "@/shared/mappings/date-time-mapper";
import IconTypeMapper from "@/shared/mappings/icon-type-mapper";
import {AzureSearchMapper} from "./base-search-response-mapper";

export class VUResultsMapper extends AzureSearchMapper<IVUSearchIndexModel> {
    public mapResult(item: IVUSearchIndexModel): SearchResult {
        let icon: IconTypes = IconTypeMapper.mapItem(item.IconType);
        let subtitle: string = DateTimeMapper.mapItem(item.SubTitle, item.Language);
        let image: SearchResultImage = this.mapImage(item.ImageUrl, item.ImageAlt);

        return new SearchResult(
            item.Id,
            item.Url,
            item.Title,
            subtitle,
            [item.IntroText],
            image,
            item.ItemType,
            item.Tags,
            icon,
            item.Categories,
            item.Details,
        );
    }
}